import { render, staticRenderFns } from "./RejectStatus.vue?vue&type=template&id=1a3de594"
import script from "./RejectStatus.vue?vue&type=script&lang=js"
export * from "./RejectStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports